import { useEffect, useState } from 'react';

/**
 * Keeps a panel mounted for its exit: `closing` while it leaves, then unmounted. Reduced motion
 * leaves at once. Opening again mid-exit keeps the same panel, with no remount.
 */
export function usePresence(show: boolean, exitMs = 140): { mounted: boolean; closing: boolean } {
  const [mounted, setMounted] = useState(show);
  useEffect(() => {
    if (show) { setMounted(true); return; }
    if (!mounted) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { setMounted(false); return; }
    const timer = setTimeout(() => setMounted(false), exitMs);
    return () => clearTimeout(timer);
  }, [show, mounted, exitMs]);
  return { mounted: show || mounted, closing: !show && mounted };
}
